import "../styles/Footer.scss";
import ami from "../images/footer/ami.svg";
import amvo from "../images/footer/amvo.svg";
import cPanel from "../images/footer/cPanel.svg";
import gptw from "../images/footer/gptw.svg";
import hecho_mexico from "../images/footer/hecho_mexico.svg";
import icann from "../images/footer/icann.svg";
import metodospago from "../images/footer/metodospago.svg";
import mx from "../images/footer/mx.svg";
import neuboxlogo from "../images/footer/nuebox_blanco.svg";
import trustwave from "../images/footer/trustwave.svg";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="content-footer">
      <div className="content-dosfooter">
        <div className="footer-top">
          <div className="footer-top-content">
            <img className="footer-nbx" src={neuboxlogo} alt="Neubox" />
          </div>
          <div className="footer-top-content2">
            <img src={trustwave} alt="Trustwave" style={{maxWidth: '95px'}} />
            <img src={mx} alt="MX Acreditado"  style={{maxWidth: '55px'}} />
            <img src={icann} alt="ICANN"  style={{maxWidth: '30px'}} />
            <img src={gptw} alt="Great Place to Work"  style={{maxWidth: '30px'}} />
            <img src={cPanel} alt="cPanel"  style={{maxWidth: '32px'}} />
            <img src={ami} alt="Asociacion de internet"  style={{maxWidth: '38px'}} />
            <img src={amvo} alt="Afiliados"  style={{maxWidth: '90px'}} />
          </div>
        </div>
        <div className="footer-bottom">
          <div className="content-botom1">
            <span>{t("footer.payment_methods")}</span>
            <img src={metodospago} alt="Trustwave" />
          </div>
          <div className="content-botom2">
            <img src={hecho_mexico} alt="Trustwave" />© 2004 - {new Date().getFullYear()} NEUBOX Internet S.A. de C.V.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
